import { render, staticRenderFns } from "./EditStage.vue?vue&type=template&id=1a9a80e6&scoped=true&"
import script from "./EditStage.vue?vue&type=script&lang=js&"
export * from "./EditStage.vue?vue&type=script&lang=js&"
import style0 from "./EditStage.vue?vue&type=style&index=0&id=1a9a80e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a80e6",
  null
  
)

export default component.exports